import React from 'react'
import { Link } from 'react-router-dom';
import { GrCertificate} from "react-icons/gr";
import { GiTakeMyMoney} from "react-icons/gi";
import { FaPeopleArrows} from "react-icons/fa";
import { AiOutlineArrowRight} from "react-icons/ai";
import { GiLetterBomb } from "react-icons/gi";
function Campus_Ambassador_discuraption() {
  return (
    <div>
  {/* ----------------Mobile View----------------*/}
    <div className='d-sm-block d-md-none'>
      <div className='pt-2 container'>
        <div className='text-center Mobile_CA_Discraption_text'>
          <h1 className='pb-1'>About Campus Ambassador</h1>
          <p className=''>Join us as a Campus Ambassador and be the catalyst for change, innovation, and connection on your campus!
          <br></br>Feel free to customize it based on the specific goals and benefits of your Campus Ambassador program.</p>
          <h1 className='py-3'>Benefits for Campus Ambassador</h1>
        </div>
      </div>
      <div className='pb-4 container'>
        <div className='row px-2'>
        <div className='col-6 pb-4 px-1'>
        <div className='shadow text-center Mobile_CA_border_icon py-4'>
        <GiLetterBomb size="40px" color="black" />
        <p className='pt-2 mobile_CA_benefit_text'>Campus Amb. letter</p>
        </div>
        </div>
        <div className='col-6 px-1 pb-4'>
        <div className='shadow text-center Mobile_CA_border_icon py-4'>
        <GrCertificate size="40px" color="black" />
        <p className='pt-2 mobile_CA_benefit_text'>Ambassador Certificate.</p>
        </div>
        </div>
        <div className='col-6 px-1'>
            <div className='shadow text-center Mobile_CA_border_icon py-4'>
            <FaPeopleArrows size="40px" color="black" />
            <p className='pt-2 mobile_CA_benefit_text'>Marketing Internship</p>
            </div>
        </div>
        <div className='col-6 px-1'>
        <div className='shadow text-center Mobile_CA_border_icon py-4'>
        <GiTakeMyMoney size="40px" color="black" />
        <p className='pt-2 mobile_CA_benefit_text'>Incentive Upto 5K</p>
        </div>
        </div>
        </div>
      </div>
    </div>

  {/* ----------------Desktop View----------------     */}
    <div className='pt-4 d-none d-md-block'>
      <div className='container pb-5'>
        <div className='row'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2 pt-2'>About Campus Ambassador</h1>
                <p>Join us as a Campus Ambassador and be the catalyst for change, innovation, and connection on your campus!<br></br>Feel free to customize it based on the specific goals and benefits of your Campus Ambassador program.</p>
                <h1 className='display-6 pt-4'>Benefits for Campus Ambassador</h1>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
      </div>
      <div className='pb-5 container'>
        <div className='row'>
        <div className='col-md-3'>
        <div className='container CA_card shadow text-center CA_border_icon py-4'>
        <GiLetterBomb size="50px" color="black" />
        <p className='pt-4 CA_benefit_text'>Campus Ambassador letter</p>
        </div>
        </div>
        <div className='col-md-3'>
        <div className='container CA_card shadow text-center CA_border_icon py-4'>
        <GrCertificate size="50px" color="black" />
        <p className='pt-4 CA_benefit_text'>Ambassador<br></br>Certificate.</p>
        </div>
        </div>
        <div className='col-md-3'>
            <div className='container CA_card shadow text-center CA_border_icon py-4'>
            <FaPeopleArrows size="50px" color="black" />
            <p className='pt-4 CA_benefit_text'>Internship Opportunity</p>
            </div>
        </div>
        <div className='col-md-3'>
        <div className='container CA_card shadow text-center CA_border_icon py-4'>
        <GiTakeMyMoney size="50px" color="black" />
        <p className='pt-4 CA_benefit_text'>Incentive<br></br> Upto 5K</p>
        </div>
        </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Campus_Ambassador_discuraption
